import React, { useEffect } from 'react';
import { login } from '../services/auth.service';
import { useAuth } from '../services/useAuth';
import { PageContainer } from '../components/PageContainer';
import { Loading } from '../components/Loading';

export const Login = () => {
    const { user, loading } = useAuth();

    useEffect(() => {
        if (!loading && !user) {
            login();
        }
    }, [loading, user])

    if (loading) {
        return (<PageContainer>
            <Loading />
        </PageContainer>)
    }
    if (!loading && user) {
        return (<PageContainer>
            <h1>Welcome {user.username}</h1>
            <p>You are already logged in.</p>
        </PageContainer>)
    }
    return null;
}